module.exports = __webpack_public_path__ + "media/1-8.70bae1f4.mp4";